import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { mobileSchema } from '../../schema/loginSchema'
import { Images } from '../../assets/scripts/Images'
import { getData, notAllowEnterNumber } from '../../assets/scripts/GeneralFunctions'
import { errorList, input_class, loginState, position_center } from '../../functions/stateList'

function RightSection() {
  const [inputs, setInputs] = useState({
    ...loginState,
  })
  const [error, setError] = useState({
    ...loginState,
  })
  const [showPassword, setShowPassword] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)

  const inputHandler = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
    setError({ ...error, [e.target.name]: '' })
  }

  const loginSubmit = (e) => {
    e.preventDefault()
    setIsSubmit(true)
    mobileSchema
      .validate(inputs, { abortEarly: false })
      .then(async function (value) {
        setIsSubmit(true)
        let api_result = await getData('admin/login', 'post', value)
        if (api_result) {
          setIsSubmit(false)
          if (api_result?.status === 200) {
            toast.success('ورود موفقیت آمیز')
            window.location.pathname = '/dashboard'
            localStorage.setItem('Token', api_result?.data?.token)
          } else {
            setError(api_result?.error)
          }
        }
      })
      .catch(function (err) {
        setError({
          ...error,
          ...errorList(err),
        })
      })

    setIsSubmit(false)
  }

  const toggleEye = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className={'w-full lg:w-1/2 h-screen relative'}>
      <img
        src={Images.shape_logo}
        width={460}
        height={420}
        className={'hidden lg:block absolute -top-36 right-0'}
        alt="milani logo"
      />
      <form onSubmit={loginSubmit} className={`${position_center} w-[300px]`}>
        <img
          src={Images.logo}
          width={250}
          height={200}
          className={'lg:hidden mb-12 mx-auto'}
          alt="milani logo"
        />
        <label className={'font-normal text-md dark:text-slate-100'} htmlFor="mobile">
          تلفن همراه
        </label>
        <input
          className={`${input_class} mt-2 ${error?.mobile ? 'mb-2' : 'mb-4 md:mb-10'}`}
          type="number"
          min="0"
          inputMode="numeric"
          pattern="[0-9]*"
          name={'mobile'}
          id={'mobile'}
          required
          value={inputs?.mobile}
          onChange={inputHandler}
          onKeyPress={(e) => notAllowEnterNumber(e, 11)}
          placeholder={'شماره تلفن همراه را وارد کنید'}
        />
        {error?.mobile && <p className={'text-rose-500 mb-2 md:mb-8'}>{error?.mobile}</p>}

        <label className={'font-normal text-md dark:text-slate-100'} htmlFor="password">
          رمز عبور
        </label>
        <div className="relative">
          <input
            className={`${input_class} mt-2 ${error?.password ? 'mb-2' : 'mb-4 md:mb-10'}`}
            type={showPassword ? 'text' : 'password'}
            name={'password'}
            id={'password'}
            required
            value={inputs?.password}
            onChange={inputHandler}
            placeholder={'رمز عبور را وارد کنید'}
          />
          <i
            className={`${
              showPassword ? 'icon-eye' : 'icon-eye-blocked'
            } absolute top-3.5 left-3 text-lg cursor-pointer dark:text-slate-100`}
            onClick={toggleEye}
          />
        </div>
        {error?.password && <p className={'text-rose-500 mb-2 md:mb-8'}>{error?.password}</p>}

        {error && typeof error === 'string' && <p className={'text-rose-500 mb-8'}>{error}</p>}
        <button
          disabled={error.password || error.mobile || isSubmit}
          type={'submit'}
          className={'mt-4 w-full text-white bg-blue rounded-md h-11 shadow-add-more text-md'}
        >
          {isSubmit ? 'در حال بررسی اطلاعات' : 'ورود'}
        </button>
      </form>
    </div>
  )
}

export default React.memo(RightSection)
